export default "__VITE_ASSET__DoTwftHO__"